export enum VerseModalScrimColorEnum {
  MEDIUM = 'medium',
  DARK = 'dark',
}
export enum VerseModalActionButtonShortcutKeyEnum {
  PRIMARY = 'Enter',
}
